import { render, staticRenderFns } from "./InProgressProjectDialog.vue?vue&type=template&id=3cff5486&scoped=true&"
import script from "./InProgressProjectDialog.vue?vue&type=script&lang=js&"
export * from "./InProgressProjectDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cff5486",
  null
  
)

export default component.exports